import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core'
import { toSignal } from '@angular/core/rxjs-interop'
import { MatIconModule } from '@angular/material/icon'
import { ActivatedRouteSnapshot, NavigationEnd, Router, RouterLink } from '@angular/router'

import { TranslateModule, TranslateService } from '@ngx-translate/core'
import { filter } from 'rxjs'

import { COMPANY_INFO_DATA_TAB_NAME } from '~/core/constants'
import { ECompanyInfoRoute, IForecastDto } from '~/core/models'

import { getCompanyBreadcrumbs } from '../../constants'

@Component({
  selector: 'app-company-breadcrumbs',
  templateUrl: './company-breadcrumbs.component.html',
  styleUrl: './company-breadcrumbs.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, MatIconModule, TranslateModule],
})
export class CompanyBreadcrumbsComponent {
  private readonly router = inject(Router)
  private readonly translate = inject(TranslateService)
  private readonly navigationEnd = toSignal(
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)),
    { initialValue: null }
  )

  readonly forecast = input<IForecastDto | null>(null)
  readonly breadcrumbs = computed(() => {
    this.navigationEnd()

    const forecast = this.forecast()

    return forecast
      ? getCompanyBreadcrumbs(forecast, this.getCompanyInfoRoute(), key =>
          this.translate.instant(key)
        )
      : []
  })

  private getCompanyInfoRoute(): ECompanyInfoRoute {
    let activeRoute: ActivatedRouteSnapshot = this.router.routerState.snapshot.root

    while (activeRoute.firstChild) {
      activeRoute = activeRoute.firstChild
    }

    return (
      (activeRoute.data[COMPANY_INFO_DATA_TAB_NAME] as ECompanyInfoRoute) ?? ECompanyInfoRoute.EARN
    )
  }
}
